import Form from "react-bootstrap/Form";

export default function InputReadOnly({
  label = null,
  type = "text",
  // Wraper styling, default to margin bottom 3 (mb-3)
  wrapperClass = "mb-3",
  value = null,
  onClick = null,
  textAreaRows = 5,
}) {
  return (
    <div
      className={wrapperClass}
      onClick={() => {
        if (typeof onClick === "function") {
          onClick();
        }
      }}
    >
      <label>{label}</label>
      <Form.Control
        type={type}
        className={`form-control`}
        value={value}
        as={type === "textarea" ? type : undefined}
        rows={type === "textarea" ? textAreaRows : undefined}
        disabled={true}
      />
    </div>
  );
}
